
import { Base } from '../base-component';

import './infographic-page-landscape.component.scss';

export class InfographicPageLandscape extends Base {

	constructor(element: Element){

		super(element)
				
	}

	init(){}
		
	bindEvents(){}

}




// WEBPACK FOOTER //
// ./components/infographic-page-landscape/infographic-page-landscape.component.ts